/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateContactResponseDataFromJSON, UpdateContactResponseDataToJSON } from './UpdateContactResponseData';
export function UpdateContactResponseFromJSON(json) {
    return UpdateContactResponseFromJSONTyped(json, false);
}
export function UpdateContactResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : UpdateContactResponseDataFromJSON(json['data'])
    };
}
export function UpdateContactResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: UpdateContactResponseDataToJSON(value.data)
    };
}
